import Icon, { IconName } from '../../../components/ui/Icon';

interface WarningInfoProps {
  iconName: IconName;
  text: string;
}
export default function WarningInfo({ iconName, text }: WarningInfoProps) {
  return (
    <div className="rounded-md bg-warning flex items-center justify-between py-3 px-4 border border-white/29 gap-2.5">
      <div className="w-6 h-6 flex items-center justify-center">
        <Icon name={iconName} />
      </div>
      <div className="border-r border-white/29 h-8" />
      <p className="text-white text-sm">{text}</p>
    </div>
  );
}
